import { useState } from "react";

export default function ProjectsTable({
  canEdit,
  canImportExport = false,
  exportToExcel,
  handleExcelUpload,
  activeFilter,
  setActiveFilter,
  setCurrentPage,
  selectedTeknopark,
  setSelectedTeknopark,
  teknoparkOptions,
  categoryFilter,
  setCategoryFilter,
  documentFilter,
  setDocumentFilter,
  dateFilter,
  setDateFilter,
  columns,
  visibleColumns,
  setVisibleColumns,
  searchText,
  setSearchText,
  tableColumns,
  paginatedProjects,
  sortConfig,
  setSortConfig,
  renderCell,
  sonlandirmaGerekenProjeler,
  projeBitmesineYakin,
  setSelectedProject,
  setEditProject,
  currentPage,
  totalPages,
  sortedProjects,
  themeMode = "light"
}) {
  const [showColumnSettings, setShowColumnSettings] = useState(false);
  const isDark = themeMode === "dark";
  const colors = {
    text: isDark ? "#e5edf6" : "#111827",
    muted: isDark ? "#9ca3af" : "#64748b",
    panel: isDark ? "#162235" : "#ffffff",
    panelBorder: isDark ? "#26364d" : "#dbe2ea",
    input: isDark ? "#101b2d" : "#ffffff",
    tableHeader: isDark ? "#162235" : "#ffffff",
    tableBorder: isDark ? "#334155" : "#ddd",
    cellBorder: isDark ? "#26364d" : "#f1f5f9",
    defaultRow: isDark ? "#111827" : "white",
    sonlandirmaRow: isDark ? "#3b1d25" : "#fee2e2",
    yaklasanRow: isDark ? "#3a2d12" : "#fef3c7",
    bitirmeRow: isDark ? "#332616" : "#fff7ed",
    tescilRow: isDark ? "#251f42" : "#ede9fe",
    activeFilter: isDark ? "#162235" : "#f3f4f6",
    button: isDark ? "#1f2d44" : "#ffffff"
  };

  const selectStyle = {
    padding: 12,
    borderRadius: 10,
    border: `1px solid ${colors.panelBorder}`,
    background: colors.input,
    color: colors.text,
    outline: "none"
  };

  const getRowBackground = (p) => {
    if (sonlandirmaGerekenProjeler.some((x) => x.id === p.id)) {
      return colors.sonlandirmaRow;
    }
    if (projeBitmesineYakin.some((x) => x.id === p.id)) {
      return colors.yaklasanRow;
    }
    if (p.sonlandirmaTarihi && p.projeBitirmeBelgesi !== "Var") {
      return colors.bitirmeRow;
    }
    if (p.projeKategorisi === "Yazılım" && p.yazilimTescilBelgesi !== "Var") {
      return colors.tescilRow;
    }
    return colors.defaultRow;
  };

  return (
    <div style={{ color: colors.text }}>
            <h2>Tüm Projeler</h2>

          {canImportExport && (
          <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
            <label
              style={{
                padding: "12px 18px",
                borderRadius: 12,
                background: "#16a34a",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer"
              }}
            >
              Excel Yükle
              <input
                type="file"
                accept=".xlsx, .xls"
                onClick={(event) => {
                  event.currentTarget.value = "";
                }}
                onChange={handleExcelUpload}
                style={{ display: "none" }}
              />
            </label>

            <button
              onClick={exportToExcel}
              style={{
                padding: "12px 18px",
                borderRadius: 12,
                border: "none",
                background: isDark ? "#243249" : "#111827",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer"
              }}
            >
              Excel'e Aktar
            </button>
          </div>
        )}

            {activeFilter !== "all" && (
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, background: colors.activeFilter, color: colors.text, padding: "10px 14px", borderRadius: 8, border: `1px solid ${colors.panelBorder}` }}>
                <strong>
                  Aktif Filtre:{" "}
                  {{
                    yaklasan: "Proje Bitmesine Yaklaşanlar",
                    sonlandirma: "Sonlandırılması Gerekenler",
                    bitirme: "Bitirme Belgesi Gerekenler",
                    tescil: "Yazılım Tescil Gerekenler",
                    db: "Değerlendirme Bekleyenler"
                  }[activeFilter]}
                </strong>

                <button
                  onClick={() => {
                    setActiveFilter("all");
                    setCurrentPage(1);
                  }}
                  style={{
                    padding: "6px 12px",
                    borderRadius: 6,
                    border: `1px solid ${colors.panelBorder}`,
                    background: colors.button,
                    color: colors.text,
                    cursor: "pointer"
                  }}
                >
                  Filtreyi Temizle
                </button>
              </div>
            )}

            <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 12,
              marginBottom: 16,
              background: colors.panel,
              padding: 16,
              borderRadius: 16,
              border: `1px solid ${colors.panelBorder}`,
              boxShadow: isDark ? "0 12px 28px rgba(0,0,0,0.18)" : "0 6px 18px rgba(0,0,0,0.05)"
            }}
          >
            <select
              value={selectedTeknopark}
              onChange={(e) => {
                setSelectedTeknopark(e.target.value);
                setCurrentPage(1);
              }}
              style={selectStyle}
            >
              {teknoparkOptions.map((tp) => (
                <option key={tp} value={tp}>
                  {tp === "all" ? "Tüm Teknoparklar" : tp}
                </option>
              ))}
            </select>

            <select
              value={categoryFilter}
              onChange={(e) => {
                setCategoryFilter(e.target.value);
                setCurrentPage(1);
              }}
              style={selectStyle}
            >
              <option value="all">Tüm Kategoriler</option>
              <option value="Yazılım">Yazılım</option>
              <option value="Ar-Ge">Ar-Ge</option>
              <option value="Tasarım">Tasarım</option>
            </select>

            <select
              value={documentFilter}
              onChange={(e) => {
                setDocumentFilter(e.target.value);
                setCurrentPage(1);
              }}
              style={selectStyle}
            >
              <option value="all">Tüm Belgeler</option>
              <option value="bitirmeVar">Bitirme Belgesi Var</option>
              <option value="bitirmeYok">Bitirme Belgesi Yok</option>
              <option value="tescilVar">Yazılım Tescil Var</option>
              <option value="tescilYok">Yazılım Tescil Yok</option>
            </select>

            <select
              value={dateFilter}
              onChange={(e) => {
                setDateFilter(e.target.value);
                setCurrentPage(1);
              }}
              style={selectStyle}
            >
              <option value="all">Tüm Süreler</option>
              <option value="expired">Süresi Geçenler</option>
              <option value="0-30">0-30 Gün Kalan</option>
              <option value="31-90">31-90 Gün Kalan</option>
              <option value="90plus">90+ Gün Kalan</option>
            </select>
          </div>

          <div
            style={{
              background: colors.panel,
              padding: showColumnSettings ? 16 : "10px 14px",
              borderRadius: 16,
              marginBottom: 12,
              border: `1px solid ${colors.panelBorder}`,
              boxShadow: isDark ? "0 12px 28px rgba(0,0,0,0.18)" : "0 6px 18px rgba(0,0,0,0.05)"
            }}
          >
            <button
              type="button"
              onClick={() => setShowColumnSettings((current) => !current)}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                border: "none",
                background: "transparent",
                color: colors.text,
                padding: 0,
                cursor: "pointer",
                fontWeight: 800,
                textAlign: "left"
              }}
            >
              <span>
                Görüntülenecek Kolonlar
                <span style={{ color: colors.muted, fontSize: 12, fontWeight: 700, marginLeft: 8 }}>
                  {visibleColumns.length}/{columns.length} seçili
                </span>
              </span>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  color: colors.muted,
                  fontSize: 13
                }}
              >
                {showColumnSettings ? "Gizle" : "Göster"} {showColumnSettings ? "▲" : "▼"}
              </span>
            </button>

            {showColumnSettings && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                  gap: 10,
                  marginTop: 14,
                  paddingTop: 14,
                  borderTop: `1px solid ${colors.panelBorder}`
                }}
              >
                {columns.map((column) => (
                  <label key={column.key} style={{ fontSize: 14, color: colors.text }}>
                    <input
                      type="checkbox"
                      checked={visibleColumns.includes(column.key)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setVisibleColumns([...visibleColumns, column.key]);
                        } else {
                          setVisibleColumns(
                            visibleColumns.filter((key) => key !== column.key)
                          );
                        }
                      }}
                      style={{ marginRight: 8 }}
                    />
                    {column.label}
                  </label>
                ))}
              </div>
            )}
          </div>

            <input
              placeholder="Firma, teknopark, proje adı veya STB kodu ara..."
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setCurrentPage(1);
              }}
              style={{
                width: "100%",
                padding: "14px 18px",
                marginBottom: 20,
                borderRadius: 14,
                border: `1px solid ${colors.panelBorder}`,
                background: colors.input,
                color: colors.text,
                fontSize: 14,
                outline: "none",
                boxShadow: isDark ? "0 10px 24px rgba(0,0,0,0.16)" : "0 4px 12px rgba(0,0,0,0.04)"
              }}
            />

            <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "75vh", border: `1px solid ${colors.tableBorder}`, borderRadius: 10, background: colors.panel }}>
              <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0, minWidth: 1400, fontSize: 14, color: colors.text }}>
                <thead style={{ background: colors.tableHeader, position: "sticky", top: 0, zIndex: 10, boxShadow: isDark ? "0 2px 12px rgba(0,0,0,0.25)" : "0 2px 10px rgba(0,0,0,0.05)" }}>
                  <tr>
                    {tableColumns.map((column) => (
                      <th
                        key={column.key}
                        onClick={() => {
                          if (!column.sortable) return;

                          setSortConfig({
                            key: column.key,
                            direction:
                              sortConfig.key === column.key && sortConfig.direction === "asc"
                                ? "desc"
                                : "asc"
                          });
                        }}
                        style={{
                          padding: "16px 14px",
                          textAlign: "left",
                          fontWeight: 700,
                          fontSize: 13,
                          color: isDark ? "#dbeafe" : "#374151",
                          borderBottom: `1px solid ${colors.cellBorder}`,
                          background: colors.tableHeader,
                          whiteSpace: "nowrap",
                          cursor: column.sortable ? "pointer" : "default",
                          userSelect: "none"
                        }}
                      >
                        {column.label}{" "}
                        {column.sortable && sortConfig.key === column.key
                          ? sortConfig.direction === "asc"
                            ? "↑"
                            : "↓"
                          : ""}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {paginatedProjects.map((p) => (
                    <tr
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.002)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                      key={p.id}
                      onClick={() => {
                        setSelectedProject(p);
                        setEditProject(p);
                      }}
                      style={{
                        cursor: "pointer",
                        transition: "0.2s",
                        background: getRowBackground(p),
                        color: colors.text
                      }}
                    >
                      {tableColumns.map((column) => (
                        <td
                          key={column.key}
                          style={{
                            padding: "14px",
                            borderBottom: `1px solid ${colors.cellBorder}`,
                            color: colors.text,
                            whiteSpace: "nowrap",
                            maxWidth:
                              column.key === "firmaAdi" ||
                              column.key === "projeAdi"
                                ? 260
                                : "auto",
                            overflow:
                              column.key === "firmaAdi" ||
                              column.key === "projeAdi"
                                ? "hidden"
                                : "visible",
                            textOverflow:
                              column.key === "firmaAdi" ||
                              column.key === "projeAdi"
                                ? "ellipsis"
                                : "clip"
                          }}
                          title={
                            column.key === "firmaAdi" ||
                            column.key === "projeAdi"
                              ? p[column.key]
                              : ""
                          }
                        >
                          {renderCell(p, column.key)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 16, marginTop: 16 }}>
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                style={{
                  padding: "8px 14px",
                  borderRadius: 6,
                  border: `1px solid ${colors.panelBorder}`,
                  background: currentPage === 1 ? (isDark ? "#111827" : "#f3f4f6") : colors.button,
                  color: currentPage === 1 ? colors.muted : colors.text,
                  cursor: currentPage === 1 ? "not-allowed" : "pointer"
                }}
              >
                ← Önceki
              </button>

              <span style={{ fontWeight: 600, color: colors.text }}>
                Sayfa {currentPage} / {totalPages || 1} — Toplam {sortedProjects.length} kayıt
              </span>

              <button
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage(currentPage + 1)}
                style={{
                  padding: "8px 14px",
                  borderRadius: 6,
                  border: `1px solid ${colors.panelBorder}`,
                  background: currentPage === totalPages || totalPages === 0 ? (isDark ? "#111827" : "#f3f4f6") : colors.button,
                  color: currentPage === totalPages || totalPages === 0 ? colors.muted : colors.text,
                  cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer"
                }}
              >
                Sonraki →
              </button>
            </div>
          </div>
        );
    }
